import { defineComponent as _defineComponent } from 'vue'
import { __ } from '@@/bits/intl'
import type { OzBaseDialogBoxButtonData } from '@@/library/v4/components/OzBaseDialogBox.vue'
import OzBaseDialogBox, { OzContainedButtonColorScheme } from '@@/library/v4/components/OzBaseDialogBox.vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OzAlertDialogBox',
  props: {
    darkMode: { type: [Boolean, String], default: 'auto' },
    iconSrc: { default: null },
    iconAlt: { default: null },
    title: null,
    body: { default: undefined },
    xShadow: { type: Boolean, default: false },
    closeButtonText: { default: undefined },
    htmlText: { default: undefined }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as { darkMode: boolean | 'auto', iconSrc: string | null, iconAlt: string | null, title: string, body: string, xShadow: boolean, closeButtonText: string, htmlText: string };





const buttons = computed((): OzBaseDialogBoxButtonData[] => {
  const closeButton = {
    text: props.closeButtonText || __('Okay'),
    emit: 'close',
    colorScheme: OzContainedButtonColorScheme.Secondary,
    testId: 'closeButton',
  }
  return [closeButton]
})

const close = (): void => {
  emit('close')
}

return { __sfc: true,props, emit, buttons, close, OzBaseDialogBox }
}

})